import React from 'react';
import { connect } from 'react-redux';
import Mcq from './questionLayout/mcq';
import SaSpeech from './questionLayout/sa';
import La from './questionLayout/la';
import WordCloud from './questionLayout/wordCloud';
import ClozeConversation from './questionLayout/clozeConversation';
import Cloze from './questionLayout/cloze';
import ClozePassage from './questionLayout/clozePassage';
import MultiSelect from './questionLayout/ms';
import LinkedQuestion from './questionLayout/linkedQuestion';

const mapStateToProps = (state) => {
	const {
		isFeedback,
		elementType,
		leftSectionProps,
		isMultiQuestion,
	} = state.rootReducer.testPageDetails;

	return {
		isFeedback,
		elementType,
		leftSectionProps,
		isMultiQuestion,
	};
};

const Question = ({
	isFeedback,
	elementType,
	leftSectionProps: { domain, qtype },
	isMultiQuestion,
}) => {
	let questionSection = {};

	if (isMultiQuestion) {
		questionSection = <LinkedQuestion key={Date.now()} />;
	} else {
		switch (!!qtype ? qtype.toLowerCase() : qtype) {
			case 'mcq':
				questionSection = <Mcq key={Date.now()} />;
				break;
			case 'ms':
				questionSection = <MultiSelect key={Date.now()} />;
				break;
			case 'sa':
			case 'sasemantic':
			case 'sakeyword':
			case 'ielts':
				questionSection = <SaSpeech key={Date.now()} />;
				break;
			case 'la':
				questionSection = <La key={Date.now()} />;
				break;
			case 'wordcloud':
				questionSection = <WordCloud key={Date.now()} />;
				break;
			case 'cloze_with_conversation':
				questionSection = <ClozeConversation key={Date.now()} />;
				break;
			case 'cloze':
				questionSection = <Cloze key={Date.now()} />;
				break;
			case 'cloze_with_passage':
				questionSection = <ClozePassage key={Date.now()} />;
				break;
			default:
				questionSection = <div></div>;
				break;
		}
	}

	return <span>{questionSection}</span>;
};

export default connect(mapStateToProps)(Question);
